import React from "react";

/*
 * Accessibility for hero background videos.
 *
 * A background video with no description is decorative: hide it from screen
 * readers so they don't announce an unlabeled media element. When the admin
 * writes a description, expose the video as an image with that text, the same
 * way an <img> uses alt.
 */
export function videoA11yProps(video) {
  const alt = (video && typeof video.alt === "string" ? video.alt : "").trim();
  return alt ? { role: "img", "aria-label": alt } : { "aria-hidden": "true" };
}

// Text input for the description, stored on the video object as `alt`.
export function VideoAltTextField({ value, onChange }) {
  const inputId = React.useRef(
    `video-alt-${Math.random().toString(36).slice(2, 11)}`
  ).current;
  const helpId = `${inputId}-help`;

  return React.createElement(
    "div",
    { className: "puck-field", style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      { className: "puck-field-label", htmlFor: inputId },
      "Video description (alt text)"
    ),
    React.createElement("input", {
      id: inputId,
      type: "text",
      className: "form-control",
      value: value?.alt || "",
      maxLength: 250,
      "aria-describedby": helpId,
      onChange: (e) => onChange({ ...value, alt: e.target.value })
    }),
    React.createElement(
      "div",
      { id: helpId, className: "form-text" },
      "Describe what the video shows for people using screen readers. Leave blank if the video is only decorative."
    )
  );
}
